import { SchemaName } from '@cewe-onsitesearch/schemas';
import { SearchResponse } from '../model/search-response.model';
import {
  DynamicQueriedContentIndicesConfig,
  DynamicQueriedContentResponse,
} from '@cewe-designsystem/util_onsitesearch-api-client/types/DynamicQueriedContentTypes';
import { InterfaceSearchProvider } from '@cewe-designsystem/util_onsitesearch-api-client/dist/InterfaceSearchProvider';

/**
 * meta search client to include adapter to search clients.
 *
 * This abstraction class can be used to create an interface to several clients, which can then be used, e.g.
 * integrate various searches and control for pattern matching or similar. Fallback solutions can also be built in this way.
 */
export class SearchClient implements InterfaceSearchProvider {
  // /**
  //  * provider to resolve order status queries.
  //  * @private
  //  */
  // private orderSearchProvider;
  //
  // /**
  //  * provider to resolve queries in an offline cache.
  //  * @private
  //  */
  // private offlineSearchProvider;

  /**
   * default search provider to resolve queries.
   * @private
   */
  private defaultSearchProvider: InterfaceSearchProvider;

  constructor(defaultProvider: InterfaceSearchProvider) {
    this.defaultSearchProvider = defaultProvider;
  }

  /**
   * @inheritDoc
   */
  async search(query: string, additionalParameters): Promise<SearchResponse> {
    return this.defaultSearchProvider.search(query, additionalParameters);
  }

  /**
   * @inheritDoc
   */
  async isReady(): Promise<boolean> {
    return this.defaultSearchProvider.isReady();
  }

  /**
   * @inheritDoc
   */
  async trackResultItemClick(queryID: string, selectedItem, position: number, indexKey: SchemaName): Promise<boolean> {
    return this.defaultSearchProvider.trackResultItemClick(queryID, selectedItem, position, indexKey);
  }

  /**
   * @inheritDoc
   */
  getDynamicContentByQuery(
    query: string,
    indicesConfig: DynamicQueriedContentIndicesConfig,
    filters: string,
  ): Promise<DynamicQueriedContentResponse> {
    return this.defaultSearchProvider.getDynamicContentByQuery(query, indicesConfig, filters);
  }
}
